/* HAND-AUTHORED (the artifact pipeline was unavailable for this scene) — film scene "f-deploy".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { FilmScene } from '../../types';

export const F_DEPLOY: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "frame",
      "id": "git",
      "x": 14,
      "y": 16,
      "w": 152,
      "h": 268,
      "lKey": "films:f-deploy.items.git.l"
    },
    {
      "k": "box",
      "id": "commit",
      "x": 26,
      "y": 48,
      "w": 128,
      "h": 48,
      "lKey": "films:f-deploy.items.commit.l"
    },
    {
      "k": "box",
      "id": "tag",
      "x": 26,
      "y": 110,
      "w": 128,
      "h": 44,
      "lKey": "films:f-deploy.items.tag.l"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "commit",
      "to": "tag"
    },
    {
      "k": "frame",
      "id": "pipe",
      "x": 178,
      "y": 16,
      "w": 152,
      "h": 268,
      "lKey": "films:f-deploy.items.pipe.l"
    },
    {
      "k": "box",
      "id": "gates",
      "x": 190,
      "y": 48,
      "w": 128,
      "h": 48,
      "lKey": "films:f-deploy.items.gates.l"
    },
    {
      "k": "box",
      "id": "image",
      "x": 190,
      "y": 110,
      "w": 128,
      "h": 52,
      "lKey": "films:f-deploy.items.image.l"
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "tag",
      "to": "gates"
    },
    {
      "k": "wire",
      "id": "w3",
      "from": "gates",
      "to": "image"
    },
    {
      "k": "frame",
      "id": "reg",
      "x": 342,
      "y": 16,
      "w": 130,
      "h": 268,
      "lKey": "films:f-deploy.items.reg.l"
    },
    {
      "k": "box",
      "id": "store",
      "x": 354,
      "y": 48,
      "w": 106,
      "h": 88,
      "lKey": "films:f-deploy.items.store.l"
    },
    {
      "k": "wire",
      "id": "w4",
      "from": "image",
      "to": "store"
    },
    {
      "k": "chip",
      "id": "dev",
      "x": 486,
      "y": 16,
      "w": 140,
      "h": 38,
      "lKey": "films:f-deploy.items.dev.l"
    },
    {
      "k": "chip",
      "id": "prod",
      "x": 486,
      "y": 62,
      "w": 140,
      "h": 38,
      "lKey": "films:f-deploy.items.prod.l"
    },
    {
      "k": "wire",
      "id": "w5",
      "from": "store",
      "to": "dev",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w6",
      "from": "store",
      "to": "prod"
    },
    {
      "k": "box",
      "id": "cluster",
      "x": 486,
      "y": 120,
      "w": 140,
      "h": 64,
      "lKey": "films:f-deploy.items.cluster.l",
      "sKey": "films:f-deploy.items.cluster.s"
    },
    {
      "k": "wire",
      "id": "w7",
      "from": "dev",
      "to": "cluster"
    },
    {
      "k": "wire",
      "id": "w8",
      "from": "prod",
      "to": "cluster"
    },
    {
      "k": "note",
      "id": "back",
      "x": 486,
      "y": 212,
      "lKey": "films:f-deploy.items.back.l"
    }
  ],
  "steps": [
    {
      "on": ["git", "commit"],
      "hot": ["commit"],
      "capKey": "films:f-deploy.steps.0.cap"
    },
    {
      "on": ["git", "commit", "pipe", "gates", "w2"],
      "hot": ["gates", "w2"],
      "capKey": "films:f-deploy.steps.1.cap"
    },
    {
      "on": ["git", "commit", "tag", "w1", "pipe", "gates", "w2", "image", "w3", "w4"],
      "hot": ["image", "w4"],
      "capKey": "films:f-deploy.steps.2.cap"
    },
    {
      "on": ["git", "commit", "tag", "w1", "pipe", "gates", "w2", "image", "w3", "w4", "reg", "store", "dev", "w5"],
      "hot": ["store", "dev", "w5"],
      "capKey": "films:f-deploy.steps.3.cap"
    },
    {
      "on": ["git", "commit", "tag", "w1", "pipe", "gates", "w2", "image", "w3", "w4", "reg", "store", "dev", "w5", "prod", "w6", "cluster", "w7", "w8", "back"],
      "hot": ["prod", "cluster", "back"],
      "capKey": "films:f-deploy.steps.4.cap"
    }
  ]
};